import {Module} from 'vuex';
import {RootState} from '@/store/root.store';
import {AccountApi} from '@/api';
import {Actions} from '@/store/actions';

export interface AccountState {
  empty: string;
}

const accountApi = new AccountApi();

export const AccountModule: Module<AccountState, RootState> = {
  state: {
    empty: '',
  },

  mutations: {},

  actions: {
    async [Actions.account.signIn](_, signIn): Promise<void> {
      await accountApi.signIn(signIn);
    },
    async [Actions.account.signOut](_): Promise<void> {
      await accountApi.signOut();
    },
    async [Actions.account.signUp](_, signUp): Promise<void> {
      await accountApi.signUp(signUp);
    },
    async [Actions.account.forgotPassword](_, forgotPassword): Promise<void> {
      await accountApi.forgotPassword(forgotPassword);
    },
    async [Actions.account.resetPassword](_, resetPassword): Promise<void> {
      await accountApi.resetPassword(resetPassword);
    },
    async [Actions.account.changePassword](_, changePassword): Promise<void> {
      await accountApi.changePassword(changePassword);
    },
    async [Actions.account.requestForChangeEmail](_, changePasswordRequestForm): Promise<void> {
      await accountApi.requestForChangeEmail(changePasswordRequestForm);
    },
    async [Actions.account.changeEmail](_, changePasswordForm): Promise<void> {
      await accountApi.changeEmail(changePasswordForm);
    },
    async [Actions.account.confirmEmail](_, confirmEmail): Promise<void> {
      await accountApi.confirmEmail(confirmEmail);
    },
    async [Actions.account.confirmNewEmail](_, confirmEmail): Promise<void> {
      await accountApi.confirmNewEmail(confirmEmail);
    },
  },
};
